import { defineStore } from 'pinia';
import { useMenuStore } from './menu';

interface DateHistoryEntry {
  date: any; 
  mensal: boolean;
}

interface State {
  currentFilters: any[]; 
  searchedFilter: any;  
  selectedWeek: any;  
  datehistory: DateHistoryEntry[];
  monthCalendarUI: number | null;
  searchedFormValues: any;
}

function getInitialWeek(){
  let curr = new Date(); 
  let first = curr.getDate() - curr.getDay() + 1;
  let last = first + 6; 
  let firstDayOfWeek = new Date(curr.getFullYear(), curr.getMonth(), first);
  let lastDayOfWeek = new Date(curr.getFullYear(), curr.getMonth(), last);
  return {
    start: firstDayOfWeek,
    end: lastDayOfWeek
  }
}

export const useEventSearch = defineStore({
  id: 'eventsearch',
  state: (): State => {
    const initialDate = getInitialWeek();
    const initialDateHistory: DateHistoryEntry = {
      date:initialDate,mensal: false
    }
    return {
      currentFilters: [],
      searchedFilter: null,
      selectedWeek: initialDate,
      datehistory: [initialDateHistory],
      monthCalendarUI: null,
      searchedFormValues: null
    }
  },
  getters: {
    getFirstWeekOfMonth():Array<Date>{
      const startOfMonth = this.datehistory[this.datehistory.length -1].date.start;
      let dayOfWeek = startOfMonth.getUTCDay();
      let daysToAdd = (dayOfWeek === 0 ? -6 : 1 - dayOfWeek); 
      let startOfWeek = new Date(startOfMonth);
      startOfWeek.setUTCHours(0, 0, 0, 0);
      startOfWeek.setUTCDate(startOfWeek.getUTCDate() + daysToAdd);
      let endOfWeek = new Date(startOfWeek);
      endOfWeek.setUTCHours(0, 0, 0, 0);
      endOfWeek.setUTCDate(endOfWeek.getUTCDate() + 6);
      return [startOfWeek,endOfWeek];
    },
  },
  actions: {
    setSearchedFormValues(submittedFormFields){
      console.log("setSearchedFormValues");
      console.log(submittedFormFields);
      this.searchedFormValues = JSON.parse(JSON.stringify(submittedFormFields));
    },
    setFieldOnFormValues(key,val){
      this.searchedFormValues[key].value = val;
    },
    updateMonthCalendarUI(month:number){
      this.monthCalendarUI = month;
    },
    updateWeeklyDateToMonthlyDate(){
      console.log("updateWeeklyDateToMonthlyDate");
      //converts the current weekly date to a monthly date
      const year = this.selectedWeek.end.getFullYear();
      let month = this.selectedWeek.end.getMonth(); 
      month = this.monthCalendarUI ?? month;
      this.setSelectedWeek({ 
        start: new Date(year, month, 1), 
        end: new Date(year, month + 1, 0) 
      });
    },
    updateMonthlyDateToWeeklyDate(){
      console.log("updateMonthlyDateToWeeklyDate");
      //converts the current monthly date to a weekly date
      const [ startOfWeek, endOfWeek ] = this.getFirstWeekOfMonth;
      this.setSelectedWeek({ start: startOfWeek, end: endOfWeek  })
    },
    removeFilterValue(propertyName){
      this.currentFilters = {
        ...this.currentFilters,
        [propertyName]: null
      }
    },
    updateSearchFilter(newFilter){
      this.searchedFilter = newFilter;
    },
    updateCurrentFilters(newCurrentFilters){
      this.currentFilters = newCurrentFilters;
    },
    setSelectedWeek(newWeek){
      const mstore = useMenuStore();
      this.datehistory.push({date: newWeek, mensal: mstore.currentSelected?.id == 3});
      this.selectedWeek = newWeek;
    }
  }
});